module.exports = __webpack_public_path__ + "static/img/card-03.b3e5ae4.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card-03.jpeg
// module id = 5XjY
// module chunks = 14